// extracted by mini-css-extract-plugin
export default {"container":"ingredient-card_container__AgUyx","image":"ingredient-card_image__YN+9a","group":"ingredient-card_group__S4mV3","name":"ingredient-card_name__FIIAZ"};